import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { AuthContext } from "../../hoc/AuthContext";
import { LOYALTY_LIST_PATH, MAX_EVENT_CHUNKS } from "./constants";
import { useProgramForm } from "./hooks/useProgramForm";
import EventChunksSection from "./components/EventChunksSection";
import ProgramDetailsFields from "./components/ProgramDetailsFields";

export default function AddLoyaltyProgram() {
  const navigate = useNavigate();
  const { id: programId } = useParams();
  const { selectedDomain } = useContext(AuthContext);
  const form = useProgramForm({
    programId,
    selectedDomain,
    onSaved: () => navigate(LOYALTY_LIST_PATH),
  });

  return (
    <Layout>
      <main>
        <div className="mx-auto max-w-7xl my-2 px-4 lg:px-0">
          <div className="bg-white rounded-2xl shadow-lg">
            <div className="mx-auto p-6 bg-slate-50 rounded-t-2xl">
              <h1 className="text-2xl font-bold tracking-tight text-gray-900">
                {form.isEdit ? "Edit Loyalty Program" : "Add Loyalty Program"}
              </h1>
              <p className="mt-1 text-sm text-gray-600">
                {form.isEdit
                  ? "Update this loyalty program and its event chunks."
                  : `Create a new loyalty program. You can add up to ${MAX_EVENT_CHUNKS} event chunks.`}
              </p>
            </div>
            {form.isLoading ? (
              <p className="p-6 text-sm text-gray-500">Loading program...</p>
            ) : (
              <form className="p-6 space-y-8" onSubmit={form.handleSubmit}>
                <ProgramDetailsFields
                  titleEn={form.titleEn}
                  setTitleEn={form.setTitleEn}
                  titleHi={form.titleHi}
                  setTitleHi={form.setTitleHi}
                  descriptionEn={form.descriptionEn}
                  setDescriptionEn={form.setDescriptionEn}
                  descriptionHi={form.descriptionHi}
                  setDescriptionHi={form.setDescriptionHi}
                  status={form.status}
                  setStatus={form.setStatus}
                  setImage={form.setImage}
                  existingImage={form.existingImage}
                />
                <EventChunksSection
                  eventChunks={form.eventChunks}
                  onChange={form.updateEventChunk}
                  onAdd={form.addEventChunk}
                  onRemove={form.removeEventChunk}
                />
                {form.error ? <p className="text-sm text-red-600">{form.error}</p> : null}
                <div className="flex flex-wrap gap-2">
                  <button
                    type="submit"
                    disabled={form.isSaving}
                    className="inline-flex items-center rounded-xl bg-cyan-500 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-600 disabled:cursor-not-allowed disabled:bg-cyan-300"
                  >
                    {form.isSaving ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    onClick={() => navigate(LOYALTY_LIST_PATH)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </main>
    </Layout>
  );
}
